import { Link } from "react-router-dom";

import PageBanner from "../../layouts/PageBanner";
import { EducationSupport } from "../../constant/theme";

const EducationalSupport = () => {
  return (
    <>
      <div className="page-content bg-white">
        <PageBanner maintitle="Home" pagetitle="Project" />

        <section className="content-inner bg-light section-pattren1">
          <div className="container">
            <div className="row align-items-center flex-column-reverse flex-lg-row">
              <div className="col-lg-12 align-self-center">
                <div className="section-head m-b30">
                  <h2 className="title mb-3 padding">
                    Empowering Indian Students through Education{" "}
                  </h2>
                </div>
              </div>
            </div>

            <div className=" dz-card blog-single sidebar">
              <div>
                <div className="dz-meta">
                  <ul>
                    <li className="post-date">
                      <i className="fa-solid fa-calendar-days"></i> September,
                      2025
                    </li>
                    {/* <li className="post-author">
                      <Link to={"#"}>
                        <i className="fa-solid fa-minus"></i> Tamil Nadu
                      </Link>
                    </li> */}
                  </ul>
                </div>
                <div className="dz-post-text">
                  <div>
                    <p>
                      "கேடில் விழுச்செல்வம் கல்வி யொருவற்கு மாடல்ல மற்றை யவை"
                      <br />
                      A wise sage once said that knowledge and education
                      are the only wealth that stands the test of time unlike
                      material possession. There is no greater joy than
                      bestowing this imperishable treasure upon a student. San
                      Antonio Tamil Sangam (SATS) has always been committed to
                      giving back to the community, particularly by empowering
                      students through education. SATS takes immense pride in
                      providing financial assistance every year through “Indian
                      Student Association Annual Scholarship” to deserving
                      Indian students pursuing Masters or Graduate studies in a
                      recognized University in San Antonio. SATS aims to ease
                      the financial burden of academically accomplished Indian
                      students studying in San Antonio, paving a way to achieve
                      their professional aspirations in this land of
                      opportunities. This scholarship enables the eligible
                      students to qualify for in-state tuition across Fall,
                      Spring, & Summer and lowers the three-course of three
                      credits semester fee by 70%. While this initiative adds
                      yet another feather in the cap of SATS – an organization
                      already distinguished by its many philanthropic endeavors,
                      SATS is encouraging our well-wishers, sponsors, and
                      supporters to join hands for this noble cause. There are
                      many other students still in need of this scholarship
                      support. "Spread the good things in our community — every
                      scholarship makes a difference."
                    </p>

                    <div className="row mb-3">
                      {/* First column with two stacked images */}
                      <div className="col-6 d-flex flex-column">
                        <div className="mb-2">
                          <img
                            src={EducationSupport.E_support1}
                            alt=""
                            className="img-fluid"
                          />
                        </div>
                      </div>

                      {/* Second column with the last image */}
                      <div className="col-6">
                        <img
                          src={EducationSupport.E_support2}
                          alt=""
                          className="img-fluid"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default EducationalSupport;
